export const GAGoalsFeaturesDataMapping = {
  ai_response: {
    event_category: 'JusIA',
    event_action: 'View AI lock',
  },
  copy_juris_content: {
    event_category: 'Jurisprudência',
    event_action: 'View copy lock',
  },
  download_juris_content: {
    event_category: 'Jurisprudência',
    event_action: 'View download lock',
  },
  copy_diarios_content: {
    event_category: 'Diários',
    event_action: 'View copy lock',
  },
  download_diarios_content: {
    event_category: 'Diários',
    event_action: 'View download lock',
  },
  copy_modelos_content: {
    event_category: 'Modelos e Peças',
    event_action: 'View copy lock',
  },
  download_modelos_content: {
    event_category: 'Modelos e Peças',
    event_action: 'View download lock',
  },
  legal_quote: {
    event_category: 'Jurisprudência',
    event_action: 'Ementa copy lock',
  },
} as const satisfies Record<string, { event_category: string; event_action: string }>

// Matches "9,90" only when NOT preceded by another digit, so prices like
// "R$ 19,90" don't accidentally trigger the experiment layout.
// Experiment: EX-2908 / plan group 171 (experiment-lawsuit-price-variant-c)
// Slack: https://jusbrasil.slack.com/archives/CD0LTJ29W/p1776189264591939
export const LAWSUIT_NO_PROMO_EXPERIMENT_PRICE_REGEX = /(?:^|\D)9,90/

export enum PlanFrequency {
  MONTHLY = 'mês',
  YEARLY = 'ano',
}

export enum PlanFrequencyLabel {
  MONTHLY = 'Mensal',
  YEARLY = 'Anual',
}
